/* global videojs:true */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

var VideojsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getTitle: function () {
    return this.player.mediainfo ? this.player.mediainfo.name : null
  },

  getPlayhead: function () {
    if (this.plugin._adsAdapter && this.plugin._adsAdapter.flags.isStarted) {
      return this.lastPlayhead
    }
    return this.player.currentTime()
  },

  getIsLive: function () {
    if (this.player.mediainfo) {
      if (typeof this.player.mediainfo.duration === 'number') {
        return this.player.mediainfo.duration < 1
      }
      return true
    }
    return null
  },

  getDuration: function () {
    if (this.player.mediainfo && typeof this.player.mediainfo.duration !== 'undefined') {
      return this.player.mediainfo.duration
    }
    return this.player.duration()
  },

  getResource: function () {
    if (VideojsAdapter.HlsJsTech.isUsed(this)) {
      return VideojsAdapter.HlsJsTech.getResource(this)
    } else if (VideojsAdapter.ShakaTech.isUsed(this)) {
      return VideojsAdapter.ShakaTech.getResource(this)
    } else if (VideojsAdapter.DashShakaTech.isUsed(this)) {
      return VideojsAdapter.DashShakaTech.getResource(this)
    }
    return this.player.currentSrc()
  },

  getBitrate: function () {
    if (VideojsAdapter.ContribHlsTech.isUsed(this)) {
      return VideojsAdapter.ContribHlsTech.getBitrate(this)
    } else if (VideojsAdapter.HlsJsTech.isUsed(this)) {
      return VideojsAdapter.HlsJsTech.getBitrate(this)
    } else if (VideojsAdapter.ShakaTech.isUsed(this)) {
      return VideojsAdapter.ShakaTech.getBitrate(this)
    } else if (VideojsAdapter.DashShakaTech.isUsed(this)) {
      return VideojsAdapter.DashShakaTech.getBitrate(this)
    }
    return null
  },

  getRendition: function () {
    if (VideojsAdapter.ContribHlsTech.isUsed(this)) {
      return VideojsAdapter.ContribHlsTech.getRendition(this)
    } else if (VideojsAdapter.HlsJsTech.isUsed(this)) {
      return VideojsAdapter.HlsJsTech.getRendition(this)
    } else if (VideojsAdapter.ShakaTech.isUsed(this)) {
      return VideojsAdapter.ShakaTech.getRendition(this)
    } else if (VideojsAdapter.DashShakaTech.isUsed(this)) {
      return VideojsAdapter.DashShakaTech.getRendition(this)
    }
    return null
  },

  getPlayerName: function () {
    var name = 'videojs'
    if (VideojsAdapter.ContribHlsTech.isUsed(this)) name += '-hls' // hls-contrib
    if (VideojsAdapter.HlsJsTech.isUsed(this)) name += '-hlsjs' // hlsjs
    if (VideojsAdapter.ShakaTech.isUsed(this)) name += '-shaka' // shaka
    if (VideojsAdapter.DashShakaTech.isUsed(this)) name += '-dash-shaka' // dash shaka
    if (VideojsAdapter.ImaAdsAdapter.isUsed(this)) name += '-ima' // ima3
    if (VideojsAdapter.OnceUXAdsAdapter.isUsed(this)) this.pluginName += '-oux' // OnceUX
    if (this.player.FreeWheelPlugin) name += '-fw' // freewheel
    if (this.player.mediainfo) name += '-bcove' // brightcove
    return name
  },

  getPlayerVersion: function () {
    var ver = this.getPlayerName()
    if (videojs.VERSION) ver += ' ' + videojs.VERSION
    return ver
  },

  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    if (typeof this.player.playbackRate() !== 'undefined') {
      return this.player.playbackRate()
    }
    return 1
  },

  getTech: function () {
    // NOTE: Videojs discourages accessing techs from plugins because they want
    // devs to develop tech-agnostic plugins. I don't think this applies to us,
    // as we need to retrieve info from each different tech.
    // https://github.com/videojs/video.js/issues/2617
    return this.player.tech({ IWillNotUseThisInPlugins: true })
  },

  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [
      'adstart', 'adend', 'adskip', 'adsready', 'adserror', 'dispose'
    ])

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references['loadstart'] = this.loadstartListener.bind(this)
    this.references['adsready'] = this.adsreadyListener.bind(this)
    this.references['play'] = this.playListener.bind(this)
    this.references['timeupdate'] = this.timeupdateListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['abort'] = this.abortListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)
    this.references['dispose'] = this.disposeListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['seeked'] = this.seekedListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['adserror'] = this.aderrorListener.bind(this)
    this.references['adsEnded'] = this.adsEndedListener.bind(this)

    if (this.player) { Object.keys(this.references).forEach(function (key) { this.player.on(key, this.references[key]) }.bind(this)) }
  },

  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) { this.player.off(key, this.references[key]) }.bind(this))
      this.references = []
    }
  },

  aderrorListener: function (e) {
    this.adsreadyListener()
    if (this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().adPlayerErrorListener) { this.plugin.getAdsAdapter().adPlayerErrorListener(e) }
  },

  loadstartListener: function (e) {
    youbora.Log.notice('Player detected ' + this.getPlayerName())
    // if (this.player.autoplay() && !this.crashed) this._startEvent()
  },

  adsreadyListener: function (e) {
    this.loadAdsAdapter()
  },

  playListener: function (e) {
    if (!this.flags.isStarted) {
      this.lastSrc = this.getResource()
      this._startEvent()
    } else {
      if (this.lastSrc && this.lastSrc !== this.getResource()) {
        this.fireStop()
        this.lastPlayhead = undefined
        this._startEvent()
        this.lastSrc = this.getResource()
      }
    }
  },

  _startEvent: function (e) {
    this.fireStart()
    if (!this.flags.isJoined) {
      if (!this.joinPolling) {
        this.joinPolling = new youbora.Timer(this._jointimePolling.bind(this), 500)
      }
      this.joinPolling.start()
    }
    this.loadAdsAdapter()
  },

  _jointimePolling: function (e) {
    if (!this.plugin.getAdsAdapter() || !this.plugin.getAdsAdapter().flags.isStarted) {
      if (typeof this.lastPlayhead === 'number' && this.lastPlayhead !== this.getPlayhead()) {
        this.fireJoin()
        if (this.joinPolling) this.joinPolling.stop()
      }
      this.lastPlayhead = this.getPlayhead()
    }
  },

  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      // if (!this.crashed && (!this.player.options_ || !this.player.options_.autoplay)) this.fireStart()
      this.fireJoin()
      if (this.joinPolling) this.joinPolling.stop()
      // Send seek end
      if (!this.flags.isPaused && this.lastSeekPlayhead && this.lastSeekPlayhead !== this.getPlayhead()) {
        this.fireSeekEnd()
        this.lastSeekPlayhead = false
      }
    }
    if (!this.flags.isJoined) {
      if (this.lastPlayhead === undefined) {
        this.lastPlayhead = this.getPlayhead()
      }
      if (this.lastPlayhead !== this.getPlayhead()) {
        this.fireStart()
        this.fireJoin()
        if (this.joinPolling) this.joinPolling.stop()
        this.lastPlayhead = undefined
      }
    }
    if (this.plugin._adsAdapter && !this.plugin._adsAdapter.flags.isStarted) {
      this.lastPlayhead = this.getPlayhead()
    }
  },

  pauseListener: function (e) {
    this.firePause()
  },

  playingListener: function (e) {
    this._startEvent()
    this.fireResume()
  },

  abortListener: function (e) {
    this.conditionalStop(e)
  },

  endedListener: function (e) {
    this.conditionalStop(e)
  },

  disposeListener: function (e) {
    this.conditionalStop(e)
  },

  conditionalStop: function (e) {
    if (!this.plugin) return null
    this.adsEnded = false
    this.fireStop()
    this.lastPlayhead = undefined
  },

  adsEndedListener: function (e) {
    this.adsEnded = true
    if (this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Postroll) {
      this.plugin.fireStop()
      this.lastPlayhead = undefined
    }
  },

  seekingListener: function (e) {
    this.fireSeekBegin({}, false)
  },

  seekedListener: function (e) {
    // We save the playhead after the seek, we will send the seeked in the next timeupdate
    this.lastSeekPlayhead = this.getPlayhead()
  },

  errorListener: function (e) {
    if (this.player.error && this.player.error()) {
      this.fireError(this.player.error().code, this.player.error().message)
      var code = Number(this.player.error().code)
      if (code === 2 || code === 4 || code < 0) {
        this.plugin.fireStop() // Fatal error
        this.lastPlayhead = undefined
        this.crashed = true
      }
    }
  },

  loadAdsAdapter: function () {
    if (this.plugin.getAdsAdapter() === null) {
      var adapter
      if (typeof google !== 'undefined' && VideojsAdapter.ImaAdsAdapter.isUsed(this)) {
        adapter = new VideojsAdapter.ImaAdsAdapter(this.player) // IMA
      } else if (VideojsAdapter.OnceUXAdsAdapter.isUsed(this)) {
        adapter = new VideojsAdapter.OnceUXAdsAdapter(this.player) // OnceUX
      } else if (this.player.ads) {
        adapter = new VideojsAdapter.FreewheelAdsAdapter(this.player) // Freewheel
      } else { // Generic
        adapter = new VideojsAdapter.GenericAdsAdapter(this.player) // Generic
      }
      this.plugin.setAdsAdapter(adapter)
    }
  }
},
// Static members
{
  // Ads Adaptrs
  GenericAdsAdapter: require('./ads/generic'),
  FreewheelAdsAdapter: require('./ads/freewheel'),
  ImaAdsAdapter: require('./ads/ima'),
  OnceUXAdsAdapter: require('./ads/onceux'),

  // Techs
  ContribHlsTech: require('./tech/contrib-hls'),
  HlsJsTech: require('./tech/hls-js'),
  ShakaTech: require('./tech/shaka'),
  DashShakaTech: require('./tech/dash-shaka')
}
)

youbora.adapters.Videojs = VideojsAdapter

module.exports = youbora.adapters.Videojs
